<div class="new-users">
  <div class="new-users__content content">
    <div class="content__header">
      <button
        *ngIf="!showFullPage && selectedUserId"
        tuiIconButton
        class="content__return-button"
        type="button"
        appearance="icon"
        iconStart="@tui.arrow-left"
        size="s"
        [tuiHint]="'common.buttons.return' | translate"
        (click)="onClickReturnButton()"
      ></button>

      <ng-container *ngIf="showFullPage">
        <h1 class="content__title">{{ 'components.newUsers.labels.title' | translate }}</h1>

        <app-hint [value]="newUsersHint"></app-hint>
      </ng-container>
    </div>

    <div [hide]="!showFullPage" class="content__list">
      <app-new-list
        class="list"
        [items]="unregistredUsers$ | async"
        [itemContentTmp]="itemListTmp"
        [(selectedId)]="selectedUserId"
        [withCounter]="true"
      ></app-new-list>

      <ng-template #itemListTmp let-item>
        <new-list-item-user [item]="item"></new-list-item-user>
      </ng-template>
    </div>

    <tui-scrollbar *ngIf="selectedUserId" class="content__content">
      <app-user-info
        mode="view"
        [userId]="selectedUserId"
        [allowDeleting]="allowDeleting"
        (saved)="onSaveEditingUser()"
        (deleted)="onDeleteUser($event)"
      ></app-user-info>
    </tui-scrollbar>
  </div>
</div>
